<div class="message-container" *ngIf="count > 0">
  <h3>Important Notices</h3>
  <span class="message-count">{{ count }}</span>
  <button
    #collapseBtn
    id="downtimeMessageCollapseBtn"
    class="btn btn-toggle"
    aria-label="Important Notices"
    [attr.aria-expanded]="expanded"
    [ngClass]="{ expanded }"
    (click)="toggle()"
    >
    <img src="/assets/images/icons/caret-down.svg" alt="down arrow" />
  </button>

  <div class="messages" *ngIf="expanded">
    <div [outerHTML]="messages"></div>
  </div>
</div>

<hr *ngIf="count > 0">
